import { render } from "./LibraryFormMatch.vue?vue&type=template&id=4b6560a2&scoped=true"
import script from "./LibraryFormMatch.vue?vue&type=script&lang=js"
export * from "./LibraryFormMatch.vue?vue&type=script&lang=js"

import "./LibraryFormMatch.vue?vue&type=style&index=0&id=4b6560a2&scoped=true&lang=css"

import exportComponent from "/Users/user/Development/spin-demo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b6560a2"]])

export default __exports__